import React from 'react';
export function Overview() {
  return <div className="flex flex-col items-center justify-center h-[60vh] text-center" data-id="element-203">
      <div className="bg-slate-100 p-6 rounded-full mb-4" data-id="element-204">
        <span className="text-4xl" data-id="element-205">👋</span>
      </div>
      <h1 className="text-2xl font-bold text-slate-800 mb-2" data-id="element-206">
        Welcome to LISF Portal
      </h1>
      <p className="text-slate-500 max-w-md" data-id="element-207">
        Select a dashboard from the sidebar to view system status, billing
        information, or manage services.
      </p>
    </div>;
}